import {
  FETCH_OT_EMP_NOTLEFT_REQUEST,
  FETCH_OT_EMP_NOTLEFT_SUCCESS,
  FETCH_OT_EMP_NOTLEFT_FAILURE,
} from "../constants/OTEmpNotLeftConstants";

import OTEmpNotLeftService from "../service/OTEmpNotLeftService";

export const fetchOTEmpNotLeft = (date) => async (dispatch) => {
  if (!date) {
    console.error("Date is required");
    return;
  }

  try {
    dispatch({ type: FETCH_OT_EMP_NOTLEFT_REQUEST });

    const data = await OTEmpNotLeftService.getAll(date);

    dispatch({
      type: FETCH_OT_EMP_NOTLEFT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_OT_EMP_NOTLEFT_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};


